import { z } from 'zod';

const MAX_FILE_SIZE = 5000000; // 5MB
const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/svg+xml"];

const thumbnailSchema = z
    .custom<File>((val) => val instanceof File, "Please upload a thumbnail")
    .refine((file) => file.size <= MAX_FILE_SIZE, `Max file size is 5MB.`)
    .refine(
        (file) => ACCEPTED_IMAGE_TYPES.includes(file.type),
        "Only .jpg, .jpeg, .png, .webp and .svg formats are supported."
    );

const translationSchema = z.object({
    name: z.string().optional()
});

export const subjectSchema = z.object({
    name: z.string().min(1, { message: "Subject name is required" }),
    slug: z.string().regex(/^[a-z0-9-]+$/, { message: "Slug must be lowercase alphanumeric with hyphens" }).optional(),
    thumbnail: thumbnailSchema.optional(),
    apiImage: thumbnailSchema.optional(),
    translations: z.record(z.string(), translationSchema).optional(),
});

export type SubjectFormValues = z.infer<typeof subjectSchema>;

const moduleTranslationSchema = z.object({
    name: z.string().optional(),
    short_description: z.string().optional(),
    long_description: z.string().optional(),
});

export const moduleSchema = z.object({
    moduleId: z.string().min(1, { message: "Module ID is required" }),
    slug: z.string().regex(/^[a-z0-9-]+$/, { message: "Slug must be lowercase alphanumeric with hyphens" }).optional(),
    ageGroup: z.number().min(0, { message: "Age group must be a positive number" }),
    name: z.string().min(1, { message: "Module name is required" }),
    shortDescription: z.string().min(1, { message: "Short description is required" }),
    longDescription: z.string().min(1, { message: "Long description is required" }),
    contentCompanyName: z.string().optional(),
    level: z.enum(['Fundamental', 'Basic', 'Intermediate', 'Advanced', '']).optional(),
    thumbnail: thumbnailSchema.optional(),
    translations: z.record(z.string(), moduleTranslationSchema).optional(),
});

export type ModuleFormValues = z.infer<typeof moduleSchema>;
